export default __webpack_public_path__ + "static/media/transcribe_slide_5.42fb6cca.png";